// 립싱크 튜닝 패널 ↔ 파이프라인 연결용 런타임 오버라이드.
// localStorage 에 저장되며, LipSync 가 청크마다 읽어 다음 문장부터 즉시 반영된다.
// (재빌드 없이 브라우저에서 파라미터 실험 → 확정값은 bobbi.config.ts 에 박는다)

import type { NaturalPipelineParams } from './pipeline';

const STORAGE_KEY = 'lipsync:natural-overrides';

export interface NaturalRuntimeOverrides {
  params?: Partial<NaturalPipelineParams>;
  blinkEnabled?: boolean;
}

export function getNaturalRuntimeOverrides(): NaturalRuntimeOverrides | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? (parsed as NaturalRuntimeOverrides) : null;
  } catch {
    return null;
  }
}

export function setNaturalRuntimeOverrides(overrides: NaturalRuntimeOverrides | null): void {
  if (typeof window === 'undefined') return;
  try {
    if (!overrides || (!overrides.params && overrides.blinkEnabled === undefined)) {
      window.localStorage.removeItem(STORAGE_KEY);
    } else {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(overrides));
    }
  } catch {
    // localStorage 접근 불가(프라이빗 모드 등) — 무시
  }
}
